<template>
    <div v-if="post" class="left">
        <div class="na-form">

            <div class="dx-fieldset">
                <div class="dx-field">
                    <div class="dx-field-label">ID:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.RegId' :readOnly="true" />
                    </div>
                </div>

                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldName}}</div>
                    <div class="dx-field-value">
                        <DxTextBox v-model:value='post.RegName' />
                    </div>
                </div>


                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldDesc}}</div>
                    <div class="dx-field-value">
                        <DxTextBox v-model:value='post.RegDescription' />
                    </div>
                </div>

                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldPosition}}</div>
                    <div class="dx-field-value">
                        <DxTextBox v-model:value='post.RegPosition' />
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldModulType}}</div>
                    <div class="dx-field-value">
                        <DxSelectBox :data-source="mtyList"
                                     :search-enabled="true"
                                     :show-clear-button="false"
                                     display-expr="MtyName"
                                     value-expr="MtyId"
                                     v-model:value="post.MtyId">
                        </DxSelectBox>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldPrice}}</div>
                    <div class="dx-field-value">
                        <DxSelectBox :data-source="priList"
                                     :search-enabled="true"
                                     :show-clear-button="false"
                                     display-expr="PriName"
                                     value-expr="PriId"
                                     v-model:value="post.PriId">
                        </DxSelectBox>
                    </div>
                </div>

                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldHideHeader}}</div>
                    <div class="dx-field-value">
                        <DxCheckBox v-model:value='post.RegHideHeader' />
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldHideInReport}}</div>
                    <div class="dx-field-value">
                        <DxCheckBox v-model:value='post.RegHideInReport' />
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldIsUploadRegion}}</div>
                    <div class="dx-field-value">
                        <DxCheckBox v-model:value='post.RegIsUploadRegion' />
                    </div>
                </div>

                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldChangedOn}}</div>
                    <div class="dx-field-value">
                        <DxDateBox :value='post.RegChangedOn' :readOnly="true" />
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldChangedBy}}</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.RegChangedBy' :readOnly="true" />
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldCreatedOn}}</div>
                    <div class="dx-field-value">
                        <DxDateBox :value='post.RegCreatedOn' :readOnly="true" />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">{{tx.FieldCreatedBy}}</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.RegCreatedBy' :readOnly="true" />
                    </div>
                </div>


                <div class="na-buttons-row">

                    <div>
                        <DxButton :text="btn.BtnSave"
                                  type="default"
                                  styling-mode="contained"
                                  @click="onSaveClick()"
                                  onmouseover="this.style.backgroundColor='#006db9'" />
                    </div>
                    <div>
                        <DxButton :text="btn.BtnDelete"
                                  type="default"
                                  styling-mode="outlined"
                                  @click="onDeleteClick()" />
                    </div>
                    <div>
                        <DxButton :text="btn.BtnCancel"
                                  type="default"
                                  styling-mode="outlined"
                                  @click="onCloseClick()" />
                    </div>

                    <div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    // @ is an alias to /src

    import { DxTextBox } from 'devextreme-vue/text-box';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import { DxButton } from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import { DxDateBox } from 'devextreme-vue/date-box';
    import '../assets/detailForm.less';
    import { confirm, alert } from "devextreme/ui/dialog"
    import $ from 'jquery';
    const baseUri = "WebApi.asmx/api/ModulRegionListService";
    export default {
        name: 'ModulRegionDetail',
        components: {
            DxButton,
            DxTextBox,
            DxDateBox,
            DxSelectBox,
            DxCheckBox
        },
        data() {
            return {
                post: null,
                tx: {
                    FieldName: this.$LanguageProvider.GetResource("fieldName", "Caption", "Name:"),
                    FieldDesc: this.$LanguageProvider.GetResource("fieldDesc", "Caption", "Beschreibung:"),
                    FieldPosition: this.$LanguageProvider.GetResource("FieldPosition", "Position", "Position:"),
                    FieldModulType: this.$LanguageProvider.GetResource("FieldModulType", "Caption", "ModulType:"),
                    FieldPrice: this.$LanguageProvider.GetResource("FieldPrice", "Caption", "Category:"),
                    FieldHideHeader: this.$LanguageProvider.GetResource("FieldHideHeader", "Caption", "Hide Header:"),
                    FieldHideInReport: this.$LanguageProvider.GetResource("FieldHideInReport", "Caption", "Hide in Report:"),
                    FieldIsUploadRegion: this.$LanguageProvider.GetResource("FieldIsUploadRegion", "Caption", "Is Upload Region:"),
                    FieldChangedOn: this.$LanguageProvider.GetResource("fieldChangedOn", "Caption", "Geändert am:"),
                    FieldChangedBy: this.$LanguageProvider.GetResource("fieldChangedBy", "Caption", "Geändert von:"),
                    FieldCreatedOn: this.$LanguageProvider.GetResource("fieldCreatedOn", "Caption", "Esrtellt am:"),
                    FieldCreatedBy: this.$LanguageProvider.GetResource("fieldCreatedBy", "Caption", "Esrtellt von:"),
                },
                btn: {
                    BtnSave: this.$LanguageProvider.GetResource("btnSave", "Caption", "Speichern"),
                    BtnDelete: this.$LanguageProvider.GetResource("btnDelete", "Caption", "Löschen"),
                    BtnCancel: this.$LanguageProvider.GetResource("btnCancel", "Caption", "Abbrechen"),
                }
            };
        },
        created: function () {
            this.$store.dispatch("getModulTypeSimpleList")
            this.$store.dispatch("getPriceListSimple")
            axios
                .get(baseUri + '/GetDetail')
                .then(res => {
                    this.post = res.data.data
                })
        },
        computed: {
            mtyList() {
                return this.$store.state.modulTypeStore.modulTypeSimpleList
            },
            priList() {
                return this.$store.state.priceStore.priceListSimple
            }
        },
        methods: {
            onCloseClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick() {
                var formData = new FormData()                
                formData.append("data", JSON.stringify(this.post))
                axios
                    .post(baseUri + '/SaveDetail', formData)
                    .then(res => {
                        if (res.data.success) { notify(`The changes were saved successfully`); }
                        else { alert(`error: ${res.data.errorMessage}`) }

                    })

            },
            onDeleteClick() {
                let result = confirm("do you really want to delete this record?", "Confirm delete");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        var formData = new FormData()
                        formData.append("data", JSON.stringify(this.post))
                        axios
                            .post(baseUri + '/Delete', formData)
                            .then(res => {
                                if (res.data.success) {
                                    notify(`The record has been successfully deleted`);
                                    $("form").attr("action", window.location.pathname + "?action=cancel").submit();
                                }
                                else { alert(`error: ${res.data.errorMessage}`) }

                            })
                    }


                });


            },
            capitalize(text) {
                return text.charAt(0).toUpperCase() + text.slice(1);
            }
        }
    }


</script>
<style>
</style>
